/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PortfolioTagRequest
 */
export interface PortfolioTagRequest {
  /**
   *
   * @type {string}
   * @memberof PortfolioTagRequest
   */
  name: string
}

/**
 * Check if a given object implements the PortfolioTagRequest interface.
 */
export function instanceOfPortfolioTagRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function PortfolioTagRequestFromJSON(json: any): PortfolioTagRequest {
  return PortfolioTagRequestFromJSONTyped(json, false)
}

export function PortfolioTagRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PortfolioTagRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
  }
}

export function PortfolioTagRequestToJSON(value?: PortfolioTagRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
